<header class="header" appClickOutside (clickOutside)="closeAllMenus()" menuClass="js-header-menu">
  <div class="header__content">
    <!-- TODO: apps launcher - the redesign shows the 3x3 dot grid but no target
         is defined for it yet, so the button is intentionally inert. -->
    @if (showAppsLauncher()) {
      <button type="button" class="apps-launcher" (click)="onAppsLauncherClick()">
        @for (dot of appsLauncherDots; track $index) {
          <span class="apps-launcher__dot"></span>
        }
      </button>
    }

    @if (!isActive('/')) {
      <a class="logo" [routerLink]="['/']" menuNavItem>
        <img class="logo__img" [src]="'assets/img/common/logo-white-' + providerWebsiteId + '.svg'" alt="" />
      </a>
    } @else {
      <a class="logo" [routerLink]="['/']" [queryParams]="{ r: 1 }" menuNavItem>
        <img class="logo__img" [src]="'assets/img/common/logo-white-' + providerWebsiteId + '.svg'" alt="" />
      </a>
    }

    <span class="header__spacer"></span>

    <div class="account">
      <button type="button" class="account__toggle" (click)="toggleAccountMenu()">
        <span class="account__info">
          <span class="account__name">{{ user?.name }}</span>
        </span>
        <span class="avatar">{{ initials }}</span>
        <svg-icon class="caret" src="assets/icons/header-2-caret-down.svg"></svg-icon>
      </button>

      @if (isAccountMenuOpen) {
        <div class="account__menu">
          @if (languages?.length) {
            <div class="account__languages">
              <!-- TODO: the design uses three letter codes (GEO / ENG), the
                   existing label.lang-short-* translations return two letters. -->
              @for (language of languages; track language) {
                <button
                  type="button"
                  class="account__language"
                  [class.account__language--active]="language === currentLanguage"
                  (click)="selectLanguage(language)"
                >
                  {{ ('label.lang-short-' + language) | translate }}
                </button>
              }
            </div>
          }
          <button type="button" class="account__menu-item" (click)="onSignOutClick()">{{ 'label.SignOut' | translate }}</button>
        </div>
      }
    </div>

    <button type="button" class="menu-toggle" (click)="toggleBurgerMenu()">
      <svg-icon class="menu-toggle__icon" src="assets/icons/header-2-menu.svg"></svg-icon>
    </button>
  </div>

  @if (isBurgerMenuOpen) {
    <div class="burger-menu">
      <div class="burger-menu__content">
        <a class="burger-menu__user" [routerLink]="['/admin/edit']" menuNavItem>
          <span class="avatar avatar--large">{{ initials }}</span>
          <div class="burger-menu__user-info">
            <div class="burger-menu__user-name">{{ user?.name }}</div>
          </div>
        </a>

        <div class="burger-menu__divider"></div>

        @if (languages?.length) {
          <div class="burger-menu__row burger-menu__row--languages">
            @for (language of languages; track language) {
              <button
                type="button"
                class="burger-menu__language"
                [class.burger-menu__language--active]="language === currentLanguage"
                (click)="selectLanguage(language)"
              >
                {{ ('label.lang-short-' + language) | translate }}
              </button>
            }
          </div>
        }

        <button type="button" class="burger-menu__row burger-menu__row--button" (click)="onSignOutClick()">
          <span class="burger-menu__text">{{ 'label.SignOut' | translate }}</span>
        </button>
      </div>
    </div>
  }
</header>
